import {IconsObject} from '@/icons/services/IconService';

export const feedbackIcons: IconsObject = {
  normal: 'mdi-comment',
  late: 'mdi-clock-alert',
  lateActive: 'mdi-clock-alert-outline',
};

export default feedbackIcons;
